import { Form, Formik, FormikProps } from 'formik';
import React, { useState } from 'react';
import Button, { ButtonThemes } from 'ui-components/button/button';
import { LabelModes } from 'ui-components/molecules/labeled-inputs/labeledInput';
import SlideOutSidebar from 'ui-components/slide-out-sidebar/slideOutSidebar';
import XGSFormDate from 'ui-components/form/date/xgsFormDate';
import { currentOrClosestBusinessDay } from 'hooks/utils';
import { useCloneWeek } from '../hooks/useCloneWeek';
import XGSFormInput from 'ui-components/form/input/xgsFormInput';
import moment from 'moment';
import XGSCheckbox from 'ui-components/xgs-checkbox/xgsCheckbox';
import { weekOptions } from 'app/data/static-load/model';
import '../cloneWeek.scss'
import ImportantMessage, { ImportantMessageTheme } from 'ui-components/molecules/important-message/importantMessage';
interface CopyMoveLaneSidebarProps {
  isOpen: boolean;
  onClose: () => void;
  isLoading: boolean;
  weekStartDate: string;
  division: string;
  refetchGetWeeks: () => void;
}

interface exclusionDay {
  dayOfWeek: string,
  fromTime: string,
  toTime: string
}

const TargetWeek: React.FC<CopyMoveLaneSidebarProps> = ({ isOpen,
  onClose, weekStartDate, division, refetchGetWeeks }) => {
  const [targetWeekStartDate, setTargetWeekStartDate] = useState<string | undefined>();
  const [weeks, setWeeks] = useState<exclusionDay[]>([]);

  const cloneWeekMutation = useCloneWeek(() => {
    refetchGetWeeks();
    onClose();
  });

  return <SlideOutSidebar
    show={isOpen}
    onClose={onClose}
    header="Clone Week"
    size="small"
    className="filter-sidebar"
  >
    <Formik
      initialValues={{
        targetWeekStartDate: "",
        description: "",

      }} onSubmit={(values) => {
        if (!targetWeekStartDate) return;
        const exclusions = weeks.map(({ dayOfWeek, fromTime, toTime }) => {
          const payload: any = {
            dayOfWeek: Number(dayOfWeek)
          };

          if (fromTime) payload.fromTime = fromTime;
          if (toTime) payload.toTime = toTime;

          return payload;
        });
        cloneWeekMutation.mutate({
          division: division,
          sourceWeekStartDate: weekStartDate,
          targetWeekStartDate: moment(targetWeekStartDate, "MM/DD/YYYY").format("YYYY-MM-DD"),
          targetWeekDescription: values.description.trim(),
          exclusions: exclusions
        });

      }}
      enableReinitialize
    >
      {(formikProps: FormikProps<any>) => (
        <Form>
          <XGSFormDate
            name="targetWeekStartDate"
            label="Target Week Start Date:"
            placeholder="Select date..."
            onDateChange={(date) => { setTargetWeekStartDate(date) }}
            value={targetWeekStartDate}
            onChange={() => null}
            minDate={new Date(currentOrClosestBusinessDay())}
            required={true}
            labelMode={LabelModes.column}
            filterDate={(date) => date.getDay() === 1}
            disableWeekends={true}
          />
          <div style={{ marginTop: "10px" }} />
          <XGSFormInput
            type="text"
            name="description"
            labelMode={LabelModes.column}
            label="Description"
          />
          <div className='clone-week-exclusions'>Select days and time ranges to exclude from cloning</div>
          <ImportantMessage theme={ImportantMessageTheme.BLUE}>Leave time empty to exclude the entire day</ImportantMessage>
          <div style={{ marginTop: "10px" }} />
          {weekOptions.map((week, index) => {
            const day = week.value;
            const selectedDay = weeks.find(item => item.dayOfWeek === day);
            const isChecked = !!selectedDay;

            return <React.Fragment key={index}>
              <XGSCheckbox
                name={week.value}
                checked={weeks.some(item => item.dayOfWeek === (week.value))}
                onChange={() => {
                  const day = week.value;

                  setWeeks(prevWeeks => {
                    const exists = prevWeeks.some(item => item.dayOfWeek === day);

                    // If already selected → remove
                    if (exists) {
                      return prevWeeks.filter(item => item.dayOfWeek !== day);
                    }

                    // Else → add new exclusion day
                    return [
                      ...prevWeeks,
                      {
                        dayOfWeek: day,
                        fromTime: "",
                        toTime: ""
                      }
                    ];
                  });
                }}
              >
                {week.label}
              </XGSCheckbox>
              {isChecked && (
                <div className="update-lane-grid-item_date">
                  <div className="update-lane-grid-item_time">
                    <label style={{ fontSize: "14px", lineHeight: "24px" }}>From</label>
                    <XGSFormInput
                      name='toTime'
                      type="time"
                      className="time-picker-label"
                      value={selectedDay?.fromTime || ""}
                      onChange={(e) => {
                        const value = e.currentTarget.value;

                        setWeeks(prev =>
                          prev.map(item =>
                            item.dayOfWeek === day
                              ? { ...item, fromTime: value }
                              : item
                          )
                        );
                      }}
                    />
                  </div>

                  <div className="update-lane-grid-item_time">
                    <label style={{ fontSize: "14px", lineHeight: "24px" }}>To</label>
                    <XGSFormInput
                      name='fromTime'
                      type="time"
                      className="time-picker-label"
                      value={selectedDay?.toTime || ""}
                      onChange={(e) => {
                        const value = e.currentTarget.value;

                        setWeeks(prev =>
                          prev.map(item =>
                            item.dayOfWeek === day
                              ? { ...item, toTime: value }
                              : item
                          )
                        );
                      }}
                    />
                  </div>
                </div>
              )}

            </React.Fragment>
          })}
          <div style={{ marginTop: "10px" }} />
          <div className="copy-move-lane-actions">
            <Button type="button" theme={ButtonThemes.gray} onClick={onClose}>Cancel</Button>
            <Button type="submit" theme={ButtonThemes.blue} spinner={cloneWeekMutation.isLoading} disabled={!targetWeekStartDate}>Confirm</Button>
          </div>
        </Form>
      )}
    </Formik>
  </SlideOutSidebar >;
};

export default TargetWeek;
